import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=1767651b&scoped=true"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=1767651b&prod&scoped=true&lang=css"
import style1 from "./HistoryDetail.vue?vue&type=style&index=1&id=1767651b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1767651b",
  null
  
)

export default component.exports